"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('setting', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M36.6859571,15.170989 C37.9363831,16.9643052 38.8162749,19.0352065 39.214667,21.2727273 L44,21.2727273 L44,26.7272727 L39.214667,26.7272727 C38.8162749,28.9647935 37.9363831,31.0356948 36.6859571,32.829011 L40.0706087,36.2136626 L36.2136626,40.0706087 L32.829011,36.6859571 C31.0356948,37.9363831 28.9647935,38.8162749 26.7272727,39.214667 L26.7272727,44 L21.2727273,44 L21.2727273,39.214667 C19.0352065,38.8162749 16.9643052,37.9363831 15.170989,36.6859571 L11.7863374,40.0706087 L7.92939134,36.2136626 L11.3140429,32.829011 C10.0636169,31.0356948 9.18372505,28.9647935 8.78533301,26.7272727 L4,26.7272727 L4,21.2727273 L8.78533301,21.2727273 C9.18372505,19.0352065 10.0636169,16.9643052 11.3140429,15.170989 L7.92939134,11.7863374 L11.7863374,7.92939134 L15.170989,11.3140429 C16.9643052,10.0636169 19.0352065,9.18372505 21.2727273,8.78533301 L21.2727273,4 L26.7272727,4 L26.7272727,8.78533301 C28.9647935,9.18372505 31.0356948,10.0636169 32.829011,11.3140429 L36.2136626,7.92939134 L40.0706087,11.7863374 L36.6859571,15.170989 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "24",
    cy: "24",
    r: "5"
  }))));
});

exports.default = _default;